module.exports = __webpack_public_path__ + "static/img/pie-chart-5.140b14a2.svg";